import { render, staticRenderFns } from "./personList.vue?vue&type=template&id=4806c303&scoped=true"
import script from "./personList.vue?vue&type=script&lang=js"
export * from "./personList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4806c303",
  null
  
)

export default component.exports